import { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { EffectFade, Thumbs } from 'swiper';
import { Modal, Alert, Overlay, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Rating from "./sub-components/ProductRating";
import Swiper, { SwiperSlide } from "../../components/swiper";
import { getProductCartQuantity } from "../../helpers/product";
import { addToCart } from "../../store/slices/cart-slice";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import { addToCompare } from "../../store/slices/compare-slice";
import { Button } from "react-bootstrap";
import { setPrincipioActivoSeleccionado } from "../../store/slices/bioequivalente-slice";
import ProductDescriptionInfo from "./ProductDescriptionInfo";
import ModalSeleccion from "../../pages/other/ModalSeleccion";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeCompare } from "@fortawesome/free-solid-svg-icons";
import cogoToast from "cogo-toast";
import { getFichaTecnica, generaNotificacion } from "../../firebase/firebase-methods";
import ProductGridListSingle from "./ProductGridListSingle";
import { getGrupoBioequivalentes } from "../../helpers/validators";

function ProductModal({ product, currency, discountedPrice, finalProductPrice, finalDiscountedPrice, show, onHide, wishlistItem, compareItem }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const { productsFull } = useSelector((state) => state.product)
  const [selectedProductColor, setSelectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize, setSelectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );
  const [productStock, setProductStock] = useState(
    product.variation ? product.variation[0].size[0].stock : product.stock
  );
  const [quantityCount, setQuantityCount] = useState(1);
  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize
  );
  const handleBioequivalente = () => {


    dispatch(setPrincipioActivoSeleccionado({ principio_activo: product.principio_activo, concentracion: product.concentracion }));
    onCloseModal()

  }

  const gallerySwiperParams = {
    spaceBetween: 10,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    thumbs: { swiper: thumbsSwiper },
    modules: [EffectFade, Thumbs],
  };

  const thumbnailSwiperParams = {
    onSwiper: setThumbsSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: true,
    slideToClickedSlide: true,
    navigation: true
  };

  const onCloseModal = () => {
    onHide()
    setThumbsSwiper(null)

  }

  const [seleccionVisible, setSeleccionVisible] = useState(false)

  const handleSeleccion = (product) => {

    setSeleccionVisible(true)
    //console.log("handleSeleccion");
    //console.log(product);

  }
 // console.log(product)
  const [showOverlay, setShowOverlay] = useState(false);
  const target = useRef(null);

  const { user } = useSelector((state) => state.user);
  const { modalidadSeleccionada } = useSelector((state) => state.modalidad);
  const [emailNotificar, setEmailNotificar] = useState(user && user.email ? user.email : "")

  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { compareItems } = useSelector((state) => state.compare);
  const [errorEmailNotificar, setErrorEmailNotificar] = useState("")
  const [successEmailNotificar, setSuccessEmailNotificar] = useState("")
  const notificarStock = () => {
    const validateEmail = async () => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailRegex.test(emailNotificar)) {
        setErrorEmailNotificar("Debe ingresar un correo válido");
      } else {
        setErrorEmailNotificar("");
        //guardo datos para notificar
        let fecha = new Date();
        let objNotificacion = {
          email: emailNotificar,
          id_producto: product.kinf2,
          nombre_producto: product.nombre_medicamento,
          notificado: false,
          fecha_solicitud: fecha,
          presku: modalidadSeleccionada.presku,
          nombre_suc: modalidadSeleccionada.nombre_suc
        }
        //console.log(objNotificacion)
        const respNotificacion = await generaNotificacion(objNotificacion)
        //console.log(respNotificacion)
        if (respNotificacion.ingresado) {
          setSuccessEmailNotificar("¡Te notificaremos cuando el producto vuelva a tener stock!")
        } else {
          setErrorEmailNotificar("Error interno, por favor intenta mas tarde")
        }

      }
    };
    validateEmail();
    //console.log(emailNotificar)

  }
  const anadirFavoritos = (product) => {
    //console.log("anadirFavoritos")
    dispatch(addToWishlist(product));
    cogoToast.success(<div className="text-center">
      <div className="pt-2 pb-2">
        <a href={process.env.PUBLIC_URL + "/favoritos"} className="boton">Ver favoritos</a>
      </div>
    </div>, { position: "top-center", heading: "Producto añadido a favoritos", hideAfter: 5 });
  }

  const anadirComparar = (product) => {
    //console.log("anadirComparar")
    dispatch(addToCompare(product));
    cogoToast.success(<div className="text-center">
      <div className="pt-2 pb-2">
        <a href="/comparacion" className="boton">Ver comparación</a>
      </div>
    </div>, { position: "top-center", heading: "Producto añadido a comparación", hideAfter: 5 });
  }

  const [enlaceFicha, setEnlaceFicha] = useState("")

  const [arrBioequivalente, setArrBioequivalente] = useState([]);

  function eliminarPrimerTexto(texto) {
    const primerEspacio = texto.indexOf(" ");
    if (primerEspacio !== -1) {
      return texto.slice(primerEspacio + 1);
    } else {
      return texto;
    }
  }
  function compararPrecios(a, b) {
    return a.precio - b.precio; // Orden ascendente (de menor a mayor)
  }


  const [bioequivalentesVisible, setBioequivalentesVisible] = useState(false);



  useEffect(() => {

    const arr = getGrupoBioequivalentes(product.kinf2)
    setArrBioequivalente(arr)

    return;
  }, [bioequivalentesVisible]);

  const [arrCat, setArrCat] = useState([]);
  useEffect(() => {
    const getFicha = async () => {
      try {
        const response = await getFichaTecnica(product.kinf)
        // console.log("respuesta desde ficha")
        // console.log(response)
        setEnlaceFicha(response[0].link)
      } catch (error) {
        //console.log(error)
        setEnlaceFicha("")
      }

    }
    //console.log(product)

    setBioequivalentesVisible(false)



    getFicha()
    // console.log("useeffect")
     
    if (!product.categorias) {
      console.log("problema")
    }
    return;
  }, [product])


  return (
    <Modal show={show} onHide={() => onCloseModal()} className="product-quickview-modal-wrapper"
      id={"modal-producto"}
      key={product.kinf2}


    >
      <Modal.Header closeButton

      ></Modal.Header>

      <div className="modal-body"

      >
        <div className="row"

        >

          {seleccionVisible ?

            <ModalSeleccion
              showModalSeleccion={seleccionVisible}
              handleCloseModalSeleccion={() => setSeleccionVisible(false)}
              objMedicamento={product}
            />
            : null
          }

          <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="product-large-image-wrapper">
              {/* <div className="single-image">
                <img
                  src={product.img_url_0}
                  className="img-fluid"
                  alt="Product"
                />
              </div> */}
              <Swiper options={gallerySwiperParams}>
                {product.image &&
                  product.image.map((img, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <div className="single-image">
                          <img
                            src={img}
                            className="img-fluid"
                            alt="Product"
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
            <div className="product-small-image-wrapper mt-15">
              <Swiper options={thumbnailSwiperParams}>
                {product.image &&
                  product.image.map((img, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <div className="single-image">
                          <img
                            src={process.env.PUBLIC_URL + img}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>


          <div className="col-md-6 col-sm-12 col-xs-12">


            <div className="product-details-content quickview-content">
              <div className="pro-details-size">
                <p className="text-capitalize">{product.laboratorio.toLowerCase()}</p>
              </div>
              <h2 className="text-capitalize">{product.nombre_medicamento.toLowerCase()}</h2>
              <div className="product-details-price">
                {discountedPrice !== null ? (

                  <Fragment>
                    <span>
                      {"$" + product.precio.toLocaleString("es-CL")}
                    </span>{" "}
                    <span className="old">
                      {"$" + product.precio.toLocaleString("es-CL")}
                    </span>
                  </Fragment>
                ) : (
                  <span>{"$" + product.precio.toLocaleString("es-CL")} </span>
                )}
              </div>
              <div className="pro-details-size ">
                <p><span className=" pr-10">{product.volumen > 0 && product.pres === 1 ? 'Precio por 100 mL/100 gr: '
                  : 'Precio por compr. fraccionado: '}</span>{product.volumen > 0 && product.pres === 1 ? "$" + (Math.trunc((product.precio * 100) / product.volumen)).toLocaleString("es-CL") : "$" + (product.precio / product.pres).toLocaleString("es-CL")}</p>
              </div>
              <div className="pro-details-size h1">
                <p className="text-capitalize">{product.principio_activo.toLowerCase()}{' '}{product.concentracion}</p>
              </div>

              <div className="pro-details-size">
                {/* <Link
        
          to={process.env.PUBLIC_URL + "/medicamentos"}
        >  */}

                <p><span className=" pr-10">{'Bioequivalente:'}</span>{product.bioequivalente === 'BE' ?
                  <img alt="bioequivalente" src="/assets/img/ficha/bioeq.png" height="40" style={{ borderRadius: "20px" }} /> :
                  product.bioequivalente === 'REF' ? 'Producto de Referencia' : 'NO'}</p>


              </div>
              <div className="pro-details-size">
                <p className="text-capitalize"><span className="pr-10">{'Concentración:'}</span>{product.concentracion.toLowerCase()}</p>
              </div>
              <div className="pro-details-size">
                <p className="text-capitalize"><span className=" pr-10">{'Contenido:'}</span>{product.contenido.toLowerCase()}</p>
              </div>
              <div className="pro-details-size">
                <p className="text-capitalize"><span className=" pr-10">{'Principio activo:'}</span>{product.principio_activo.toLowerCase()}</p>
              </div>
              <div className="pro-details-size">
                <p className="text-capitalize"><span className="pr-10">{'Clasificación terapéutica:'}</span>{product.clas_terapeutica.toLowerCase()}</p>
              </div>
              {/* {
                product.categorias.length > 0 ?
                  <div className="pro-details-size">
                    <p><span className=" pr-10">{'Categoria:'}</span>                {
                      product.categorias.length > 0 ? product.categorias.map((element, index) => {
                        console.log("elemento: "+element)
                        if (element === "SIN CATEGORIA") {
                          return
                        }
                        return (
                          <span key={index} className="text-capitalize">{index > 0 ? " - " : null}{element.toLowerCase()}</span>
                        )
                      })

                        :
                        null}</p>
                  </div>
                  : null
              } */}
              <div className="pro-details-size">
                <p><span className="pr-10">{'Refrigerado:'}<span>{product.refrigerado ? ' Si' : ' No'} </span></span></p>
                {!product.refrigerado ? null :
                  <Alert variant="warning" className="p-2">Este producto requiere refrigeración, asegúrate que al recibirlo puedas mantener la temperatura necesaria.</Alert>
                }
              </div>
              <div className="pro-details-size">
                
                <p><span className=" pr-10">{'Condición de venta:'}</span>
                  {
                    product.tipo_venta
                  }
                </p>
                {
                  product.tipo_venta ==="Receta Medica Retenida" ?
                    <Alert variant="warning"><strong>{"Sólo venta con Receta Electrónica o Receta Digitalizada"}</strong></Alert>
                    : null
                }
              </div>

              <div className="pro-details-size">
                <p><span className=" pr-10">{'Registro sanitario ISP:'}</span>{product.reg_sanitario}</p>
              </div>

              <div className="pro-details-size">
                <p><span className=" pr-10">{'Programa de apoyo paciente:   '}<span> {product.pap_maestro ?

                  <span>{"SI "}
                    {/* <Button variant="inline" ref={target} onClick={() => setShowOverlay(!showOverlay)}>
                    <i style={{ fontWeight: "bold", color: "orange", fontSize: 20, verticalAlign: "top" }} className="pe-7s-info" />  {"Mas Información"}
                  </Button> */}
                  </span>

                  : "NO"
                }</span></span></p>


              </div>
              {
                product.pap_maestro ?
                  <div className="pro-details-size">
                    <p><span> {"Por la compra de "}{product.pap.descripcion[0]} {product.pap.descripcion[0] > 1 ? " cajas, " : " caja, "} {"recibes "} {product.pap.descripcion[4]} {" caja sin costo"}</span></p>
                  </div>
                  : null
              }



              {enlaceFicha ?
                <div className="pt-2">
                  <Link
                    className="boton"
                    to={enlaceFicha}>Ver ficha tecnica</Link>
                </div>

                :

                null}

              {/* {product.bioequivalente === 'BE' || product.bioequivalente === 'REF' ?
                <div className="pro-details-size py-3">
               

                  <Button 
                  onClick={() => handleBioequivalente()} 
                  
                  style={{ borderRadius: "20px", backgroundColor: "yellow", color: "red", border: "none", fontSize: "1rem", cursor: "pointer", fontWeight: "bold" }} >Ver bioequivalentes</Button>   </div>
                :
                <br></br>} */}



              {
                product.stock === 0 ?
                  <div>

                    <div className="d-flex">
                      <input
                        type="text"
                        style={{ borderRadius: "30px", borderColor: "#694B99" }}
                        defaultValue={emailNotificar}
                        onChange={text => setEmailNotificar(text.target.value)}
                        placeholder="Ingresa tu correo"
                      />
                      <Button

                        style={{ backgroundColor: "#694B99", borderRadius: "30px", border: "none", paddingInline: "10px", width: "200px" }}
                        onClick={() => notificarStock()}
                      >{"Notificar stock"}</Button>
                    </div>
                    {
                      errorEmailNotificar ?
                        <p className="text-danger">{errorEmailNotificar}</p>
                        :
                        null
                    }
                    {
                      successEmailNotificar ?
                        <p className="text-success">{successEmailNotificar}</p>
                        :
                        null
                    }

                  </div>
                  : null
              }
            </div>

            <div
              className="text-center pt-20"
            >
              {(product.bioequivalente === 'BE' || product.bioequivalente === 'REF') && arrBioequivalente.length > 0 ?
                <Button
                  //  onClick={() => handleBioequivalente()} 

                  style={{
                    borderRadius: "20px",
                    backgroundColor: "yellow",
                    color: "red",
                    border: "none",
                    fontSize: "1rem",
                    cursor: "pointer",
                    fontWeight: "bold"
                  }}

                  onClick={() => setBioequivalentesVisible(!bioequivalentesVisible)}
                >
                  {!bioequivalentesVisible ? "Ver bioequivalentes" : "Ocultar bioequivalentes"}
                </Button>

                : null
              }
            </div>

          </div>
          {bioequivalentesVisible ?
            <div className="pt-20">
              <p className="fs-5 text-capitalize">{arrBioequivalente.length > 0 ? "Mostrando alternativas bioequivalentes de " : "Actualmente no contamos con alternativas bioequivalentes de "}<strong className="text-capitalize">{product.nombre_medicamento + " (" + product.contenido + ")"}</strong></p>
              <div className="d-flex row">
                {
                  arrBioequivalente.map(product => (
                    <div className="col-xl-4 col-sm-6" key={product.kinf2}>
                      <ProductGridListSingle
                        spaceBottomClass={'pb-20'}
                        product={product}
                        currency={currency}
                        cartItem={
                          cartItems.find(cartItem => cartItem.id === product.kinf2)
                        }
                        wishlistItem={
                          wishlistItems.find(
                            wishlistItem => wishlistItem.id === product.kinf2
                          )
                        }
                        compareItem={
                          compareItems.find(
                            compareItem => compareItem.id === product.kinf2
                          )
                        }
                      />
                    </div>
                  ))
                }
              </div>
            </div>


            :

            null
          }
        </div>
      </div>
    </Modal>
  );
}

ProductModal.propTypes = {
  currency: PropTypes.shape({}),
  discountedprice: PropTypes.number,
  finaldiscountedprice: PropTypes.number,
  finalproductprice: PropTypes.number,
  onHide: PropTypes.func,
  product: PropTypes.shape({}),
  show: PropTypes.bool,
  wishlistItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({})
};

export default ProductModal;
